import {SessionTagCodes} from '../enums';
import {PlayerSession, SessionTag, TeamSession} from '../interfaces';

const createSessionTagFilter = (sessionTagCodes: SessionTagCodes[]) => {
  return (session: TeamSession | PlayerSession) =>
    (session.sessionTags ?? []).filter((sessionTag: SessionTag) =>
      sessionTagCodes.includes(sessionTag.code as SessionTagCodes),
    ).length > 0;
};

export {createSessionTagFilter};
